module.exports = __webpack_public_path__ + "fonts/GT-Thin.11c703f1.otf";